<!-- Cabezal Aistente -->

<div class="css-Cabezal cabezal" id="asistente-cabezal">
    <div class="css-cabezal_asistencia cabezalasistencia">
        <div class="css-contenido_cabezal contenidocabezal">
            <!-- Instance of sub-component comp-iconoasistenciaenlinea -->
            <div data-wcfid="iconoasistenciaenlinea" class="css-icono_asistencia_en_linea-1 iconoasistenciaenlinea"
                id="comp_iconoasistenciaenlinea">
                <img src="assets/images/vectors82456697.svg" width="26.88818359375px" height="21.544921875px"
                    data-wcfid="vector" class="css-Vector-1 vector">
            </div>
            <p data-wcfid="nombreasistencia" class="css-nombre_asistencia nombreasistencia">Asistencia en línea</p>
        </div>
        <div class="css-acciones_cabezal accionescabezal">
            <button id="button_accion_cerrar_cabezal" *ngIf="!ctx.hideAllButtonsForm"
                class="css-button_accion_cerrar_cabezal button_accion_cerrar_cabezal" (click)="cerrar()">
                <div class="css-icono_cerrar icono_cerrar">
                    <img src="assets/images/vectors82552051.svg" width="12px" height="12px"
                        class="css-Vector_vector-1 vector_vector_1">
                </div>
            </button>
        </div>
    </div>
</div>

<!-- 
< Cabezal Asistente-->
<div *ngIf="false && modo=='asistente'" class="css-Cabezal-1 cabezal">
    <div class="css-cabezal_asistente effect-sombras_bpscabezal_asistente_en_linea cabezal_asistente on">
        <div class="css-Contenido contenido">
            <!-- <div class="css-Empresa empresa">
                <p class="css-Nombre_empresa nombre_empresa">Rosetta S.A</p>
            </div> -->
            <p class="css-Asistente asistente">Asistente en línea</p>
        </div>

        <div class="css-Lupa lupa">
            <a class="css-a_Icono_Buscador_Cabezal a_icono_buscador_cabezal" (click)="cerrar()">
                <img src="assets/images/basecomponents-images/vectors58635935.svg" width="17.048095703125px"
                    height="17.05810546875px" class="css-Vector vector">
            </a>
        </div>
        <div class="css-Switchchat switchchat" *ngIf="permite_chat">
            <div class="css-Switch_Chat_Notificacion-1 switch_chat_notificacion">
                <div class="css-Icono_Chat-1 icono_chat">
                    <div class="css-div_created1 div_created1">
                        <img src="img/vectors5321923.svg" width="18px" height="15.75px"
                            class="css-support_agent supportagent">
                    </div>
                </div>
                <div class="css-num_mensajes-1 num_mensajes nummensajes-off">
                    <p class="css-s_1-1 s1">1</p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Cabezal Asistente con buscador-->
<div *ngIf="false && modo=='asistente2'" class="css-Cabezal-1 cabezal">
    <div class="css-cabezal_asistente effect-sombras_bpscabezal_asistente_en_linea cabezal_asistente on">
        <div class="css-Contenido contenido">
            <div class="css-Empresa empresa">
                <p class="css-Nombre_empresa nombre_empresa">Rosetta S.A</p>
            </div>
            <p class="css-Asistente asistente">Asistente en línea</p>
        </div>

        <div class="css-Lupa lupa">
            <a href="#" class="css-a_Icono_Buscador_Cabezal a_icono_buscador_cabezal">
                <img src="img/vectors60461140.svg" width="17.048095703125px" height="17.05810546875px"
                    class="css-Vector vector">
            </a>
        </div>
        <div class="css-Switchchat switchchat">
            <div class="css-Switch_Chat_Notificacion-1 switch_chat_notificacion">
                <div class="css-Icono_Chat-1 icono_chat">
                    <div class="css-div_created1 div_created1">
                        <img src="img/vectors5321923.svg" width="18px" height="15.75px"
                            class="css-support_agent supportagent">
                    </div>
                </div>
                <div class="css-num_mensajes-1 num_mensajes nummensajes-off">
                    <p class="css-s_1-1 s1">1</p>
                </div>
            </div>
        </div>
    </div>

    <div class="css-cabezal_busquedas cabezal_busquedas">
        <div class="css-Titulo_ titulo_">
            <a href="#" class="css-a_Enlace a_enlace">
                <div class="css-Icono_Flecha_Izda_Grande-1 icono_flecha_izda_grande">
                    <img src="img/vectors5554830.svg" width="16px" height="16px" class="css-arrow_back arrowback">
                </div>
            </a>
            <p class="css-Titulo_Buscador titulo_buscador">Cuál es tu consulta</p>
        </div>
        <div class="css-Buscador-1 buscador">
            <div class="css-Icono_Lupa-2 icono_lupa">
                <img src="img/vectors524415652.svg" width="17.048095703125px" height="17.058135986328px"
                    class="css-Vector-3 vector">
            </div>
            <input type="text" class="css-input_text_Buscador-1 input_text_buscador" name="comp_buscador">
        </div>
    </div>
</div>

<!-- Cabezal Chat-->
<div *ngIf="false && modo=='chat'" class="css-Cabezal-1 cabezal">
    <div class="css-cabezal_asistente effect-sombras_bpscabezal_asistente_en_linea cabezal_asistente on">
        <div class="css-Contenido contenido">
            <div class="css-Empresa empresa-diff1">
                <p class="css-Nombre_empresa nombre_empresa-diff1">Rosetta S.A</p>
            </div>
            <p class="css-Chat chat chat-diff1">Chat con el asesor</p>
        </div>

        <img src="img/5bf31c8fd79bc13048f1c3aad7defd30ed1eac64.png" width="46px" height="46px"
            class="css-Vector_Switch_asistente vector_switch_asistente vector_switch_asistente-diff1">
    </div>
</div>